module.exports = __webpack_public_path__ + "static/tsn-hero-28241f47518e71b58c85fcefa0a728a1.mp4";